
(function($, root){

  var styles = [
    'background: linear-gradient(#333, #000)'
    , 'color: #F9B949'
    , 'display: inline-block'
    , 'font-weight: bold'
    , 'padding: 5px 0'
  ].join(';');

  var s = "background: linear-gradient(#F9B949, #ee9a08); color: #fff; padding: 5px 0;";
  var c = "background: linear-gradient(#474744, #20201f); color: #fff; padding: 5px 0;";
  var o = "background: linear-gradient(#7baaff, #2f79ff); color: #fff; padding: 5px 0;";

  console && console.log && console.log("\n %c ✰ %c Loading Selex %c ✰ %c ❤️ Love coding? Join us at %c http://www.openmindonline.it \n\n", s, styles, s, c, o);

  var Log = new Logger("Core");

  root.App = {};

  // shorthand to main objects
  root.App.Window = $(window);
  root.App.Document = $(document);
  root.App.Html = $(document.documentElement);
  root.App.Head = $(document.head);
  root.App.Body = $(document.body);
  root.App.HtmlBody = $(App.Html).add(App.Body);


  root.App.on = function(){ return _on.apply(this, arguments) };
  root.App.one = function(){ return _one.apply(this, arguments) };
  root.App.trigger = function(){ return _trigger.apply(this, arguments) };
  root.App.off = function(){ return _off.apply(this, arguments) };


  function isProtectedName(n) {
    return ["add", "Events", "create" ,"trigger" , "on", "one", "off", "_destroy", "_init", "jsonDA", "context"].indexOf(n) > -1;
  }


  root.App.Utils = new function() {

    this.Events = {
      Init: "utils:init:all",
      Destroy: "utils:destroy:all",
      Close: "utils:close:all",
      Open: "utils:open:all"
    };


    this.on = function(){ return _on.apply(this, arguments) };
    this.one = function(){ return _one.apply(this, arguments) };
    this.trigger = function(){ return _trigger.apply(this, arguments) };
    this.off = function(){ return _off.apply(this, arguments) };
    this.context = 'Utils';

    this.add = function(name, methods) {
      if ( !name ) {
        throw "No name specified, please provide one.";
      }

      if ( isProtectedName(name)  ) {
        throw name + " is not a valid name.";
      }

      if ( name in this ) {
        throw name + " already used.";
      }

      function U() {
        Log.d(`Util ${name} ⇢ [ ok ]`);
      }
      methods.on = this.on;
      methods.trigger = this.trigger;
      U.prototype = methods;

      this[ name ] = new U();

      return this[ name ];

    };

  };


  root.App.Components = new function() {

    this.Events = {
      Init: "components:init:all",
      Destroy: "components:destroy:all",
      Close: "components:close:all",
      Open: "components:open:all"
    };

    this.on = function(){ return _on.apply(this, arguments) };
    this.one = function(){ return _one.apply(this, arguments) };
    this.trigger = function(){ return _trigger.apply(this, arguments) };
    this.off = function(){ return _off.apply(this, arguments) };
    this.context = 'Components';

    this.create = function(name, methods) {
      if ( !name ) {
        throw "No name specified, please provide one.";
      }

      if ( isProtectedName(name) ) {
        throw name + " is not a valid name.";
      }

      if ( name in this ) {
        throw name + " already used.";
      }


      // Create a fake class for each component
      function C(){
        Log.d(`Component ${name} ⇢ [ ok ]`);
      };
      methods.on = this.on;
      methods.trigger = this.trigger;
      C.prototype = methods;

      this[ name ] = new C();

      return this[ name ];

    };

  };
  
  root.App.Backoffice = new function() { 
    
	this.Events = {
      Init: "backoffice:init:all",
      Destroy: "backoffice:destroy:all",
      Close: "backoffice:close:all",
      Open: "backoffice:open:all"
    };

    this.on = function(){ return _on.apply(this, arguments) };
    this.one = function(){ return _one.apply(this, arguments) };
    this.trigger = function(){ return _trigger.apply(this, arguments) };
    this.off = function(){ return _off.apply(this, arguments) };
    this.context = 'Backoffice';

    this.create = function(name, methods) {
      if ( !name ) {
        throw "No name specified, please provide one.";
      }

      if ( isProtectedName(name) ) {
        throw name + " is not a valid name.";
      }

      if ( name in this ) {
        throw name + " already used.";
      }


      // Create a fake class for each component
      function C(){
        Log.d(`Backoffice component ${name} ⇢ [ ok ]`);
      };
      methods.on = this.on;
      methods.trigger = this.trigger;
      C.prototype = methods;

      this[ name ] = new C();

      return this[ name ];

    };

  };


  root.App.Pages = new function() {

    this.Events = {
      Init: "pages:init:all",
      Destroy: "pages:destroy:all",
      Close: "pages:close:all",
      Open: "pages:open:all"
    };

    this.on = function(){ return _on.apply(this, arguments) };
    this.one = function(){ return _one.apply(this, arguments) };
    this.trigger = function(){ return _trigger.apply(this, arguments) };
    this.off = function(){ return _off.apply(this, arguments) };
    this.context = 'Pages';

    this.create = function(name, methods) {
      if ( !name ) {
        throw "No name specified, please provide one.";
      }

      if ( isProtectedName(name)  ) {
        throw name + " is not a valid name.";
      }

      if ( name in this ) {
        throw name + " has been already declared.";
      }

      function P() {
        Log.d(`Page ${name} ⇢ [ ok ]`);
      }
      methods.on = this.on;
      methods.trigger = this.trigger;
      P.prototype = methods;

      this[ name ] = new P();

      return this[ name ];

    };


    this._init = function() {
      var dependsOn = App.Body.data('include');
      if (dependsOn) {
        dependsOn = dependsOn.split(";");
        Log.log("Required dependencies:", dependsOn);
        for (var i = 0, l = dependsOn.length; i < l; i++) {
          var dep = dependsOn[i];
          dep = $.trim(dep);

          Log.i("loading dependency:", dep);
          var page = this[dep];
          if (page && page.init && page.init.call) {
            page.init.call(page);
          } else {
            Log.w(`Dependency ${dep} not resolved`);
          }
        }
      }

      var Page = null;
      var ctrl = App.Body.data('controller') || $('[data-controller]').not('[data-controller=""]').data('controller');

      if (ctrl) {
        ctrl = App.Utils.Inflector.camelize(ctrl);

        if (Page = this[ctrl]) {
          Log.i("Asking controller to initialize:", ctrl);
          if (Page.init && Page.init.call) {
            Page.init.call(Page);
            Log.i(`Controller ${ctrl} initialized.`);
          } else {
            Log.w("Controller has no method 'init':", ctrl);
          }
        } else {
          Log.w("No controller defined for:", ctrl);
        }
      } else {
        Log.w("No controller defined.");
      }
    };

  };


  root.Editor = new function() {

    this.Events = {
      Init: "editor:init:all",
      Destroy: "editor:destroy:all",
      Close: "editor:close:all",
      Open: "editor:open:all"
    };

    this.on = function(){ return _on.apply(this, arguments) };
    this.one = function(){ return _one.apply(this, arguments) };
    this.trigger = function(){ return _trigger.apply(this, arguments) };
    this.off = function(){ return _off.apply(this, arguments) };

    this.add = function(name, methods) {
      if ( !name ) {
        throw "No name specified, please provide one";
      }

      if ( isProtectedName(name)  ) {
        throw name + " is not a valid name";
      }

      if ( name in this ) {
        throw name + " already used";
      }

      function E() {
        Log.d(`Editing util ${name} ⇢ [ ok ]`);
      }
      methods.on = this.on;
      methods.trigger = this.trigger;
      E.prototype = methods;

      this[ name ] = new E();

      return this[ name ];

    };

  };

  function _wrap(fnName) {
    return function() {
      for ( var name in this ) {
        if ( this.hasOwnProperty(name) ) {
          if (  ! isProtectedName(name)  ) {
            var wrap = this[ name ];
            Log.d( name, fnName + "..." );
            wrap[ fnName ] && wrap[fnName].call(wrap);
          }
        }
      }
    }
  }


  var _on = function(event, fn) {
    var $this = $(this);
    $this.on.apply($this, arguments);
    return this;
  };

  var _one = function() {
    var $this = $(this);
    $this.one.apply($this, arguments);
    return this;
  };

  var _off = function() {
    var $this = $(this);
    $this.off.apply($this, arguments);
    return this;
  };

  var _trigger = function(event, args) {
    var
      $this = $(this),
      e = $.Event(event);

    $this.trigger.apply($this, [e].concat(Array.prototype.slice.call(arguments, 1)));
    // Log.d("Triggering %s", event);
    return e.result !== false;
  };


  root.App.Utils._init = root.App.Components._init = root.App.Backoffice._init = function() {
    var self = this;
    _wrap("init").call(this);
    setTimeout(function(){
      self.trigger(self.Events.Init);
      Log.d("All 'init' events have been emitted");
    }, 0);
  };

  root.App.Utils._destroy = root.App.Components._destroy = function() {
    _wrap("destroy").call(this);
    this.trigger(this.Events.Destroy);
    Log.d(`All destroy events have been emitted on ${this.context}`);
    Log.d("---");
  };


})(jQuery, window);
